import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=3d332fc6&"
import script from "./FooterPage.vue?vue&type=script&lang=js&"
export * from "./FooterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports